import React from "react";
import { SectionWithShapes, SectionTitle } from "../common";

const PARTICIPANTS_GRAPH_IMAGE = "/video/graph.png";

/**
 * Participants overview section: heading + graph image.
 * Uses SectionWithShapes so decorative shapes appear; image aligns with section background.
 */
const ParticipantsOverview: React.FC = () => {
  return (
    <SectionWithShapes id="participants-overview">
      <SectionTitle
        subtitle="[ OUR INITIATIVES ]"
        title="Participants Overview"
        textCenter
      />
      <div className="participants-overview__figure">
        <img
          src={PARTICIPANTS_GRAPH_IMAGE}
          alt="Participants overview: teachers trained, partner schools, and overall program rating"
          className="participants-overview__img"
        />
      </div>
    </SectionWithShapes>
  );
};

export default ParticipantsOverview;
